export default "__VITE_ASSET__DmKu7AWH__"